<template>
  <div class="swiper-card game-card">
    <div class="game-bg"></div>
    <div class="corner-radius-blur newsle"></div>

    <div class="question-content">
      <h1>{{ slide.question }}</h1>

      <div class="options">
        <div v-for="option in slide.options" :key="option.slug" class="option" :class="{'other-selected' : selected && selected !== option.slug}" @click="didSelect(option)">
          <div class="option-group">
            <span class="title">{{ option.answer }}</span>
          </div>
        </div>
      </div>

      <button :disabled="!selected" @click="next()">Next Question</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
    },

    data() {
      return {
        selected: false
      }
    },

    methods: {
      didSelect(option) {
        this.selected = option.slug; 
      },

      next() {
        this.EventBus.$emit('swiper:next')
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  $border-radius: 15px;
  $purple: #9000D4;
  $white: #fff;
  $purple-faded-bg: rgba(144, 0, 212, 0.5);
  $purple-box-shadow: 0px 4px 0px rgba(144, 0, 212, 0.4), 0px 0px 150px rgba(144, 0, 212, 0.1);
  $yellow-box-shadow: 0px 4px 0px rgba(249, 222, 75, 0.4), 0px 0px 150px rgba(249, 222, 75, 0.1);

  .game-bg {
    background: linear-gradient(180deg, #03132F 0%, rgba(144, 0, 212, 0.5) 99.99%);
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 0;
  }

  .game-card {
    align-items: center;
  }

  .question-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 1rem;
    z-index: 10;
  }

  h1 {
    font-size: 50px !important;
    line-height: 100% !important;
    font-family: 'Creighton' !important;
    font-weight: normal;
    text-wrap: balance;
  }

  button {
    border-radius: $border-radius;
    box-shadow: $yellow-box-shadow;

    &:disabled {
      opacity: .3;
      cursor: not-allowed;
    }
  }

  .options {
    position: relative;
    z-index: 15;
    display: flex;
    flex-direction: column;
    grid-gap: 1rem;
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
    margin: 2rem 0 3rem 0;

    .option {
      cursor: pointer;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 0.75rem 1.5rem;
      height: auto;
      min-height: 82px;
      transition: all 0.2s ease-in-out;
      border-radius: $border-radius;
      background: $purple-faded-bg;
      box-shadow: $purple-box-shadow;

      .option-group {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 0.25rem;
        width: 100%;
        margin-left: 1rem;
      }

      .title {
        font-size: 16px;
        text-align: center;
        margin-bottom: 0;
        line-height: 150%;
      }

      &.other-selected {
        opacity: 0.25;
      }
    }
  }
</style>